import React from 'react';

import { NoCollapseArrayStringContainer } from './NoCollapseArrayString.style';
export interface ArrayStringTableCellTypes {
  type: 'stringArray';
  data: Array<string>;
}

interface Props {
  /** dane przychodzące */
  data: Array<string>;
}
/**
 * Komponent generowany dla typu tablica stringów nierozwijalna
 *
 */
export default function NoCollapseArrayString({ data }: Props): JSX.Element {
  return (
    <NoCollapseArrayStringContainer>
      {data.length ? (
        <ul>{data.map((row: string, index: number) => (row.length > 0 ? <li key={index}>{row}</li> : null))}</ul>
      ) : (
        data
      )}
    </NoCollapseArrayStringContainer>
  );
}
